"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Error = exports.EditableText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colorUtils = require("../../utils/color-utils");
var _palette = require("../../styles/palette");
var _partials = require("../../styles/partials");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

var EditableText = exports.EditableText = _styledComponents["default"].div.withConfig({
  displayName: "field-styled-components__EditableText",
  componentId: "sc-1hg38yd-0"
})(["", ";border-radius:2px;cursor:text;margin:-1px -8px;padding:1px 8px;transition:0.2s background ease-out;&:hover{background:", ";transition:none;}"], _partials.truncate, (0, _colorUtils.transparentize)('#ebebeb', 0.65));
var Title = exports.Title = _styledComponents["default"].label.withConfig({
  displayName: "field-styled-components__Title",
  componentId: "sc-1hg38yd-1"
})(["display:block;font-size:14px;line-height:20px;margin-bottom:4px;"]);
var Error = exports.Error = _styledComponents["default"].div.withConfig({
  displayName: "field-styled-components__Error",
  componentId: "sc-1hg38yd-2"
})(["display:block;color:", ";font-size:12px;margin:", ";line-height:", ";height:", ";opacity:", ";", " ", ""], _palette.commonPalette.red, function (p) {
  return p.inline ? 0 : '12px 0';
}, function (p) {
  return p.inline ? '40px' : '12px';
}, function (p) {
  return p.inline ? 0 : '9px';
}, function (p) {
  return p.visible ? 1 : 0;
}, function (_ref) {
  var position = _ref.position;
  return position ? "position: ".concat(position, ";") : '';
}, function (_ref2) {
  var left = _ref2.left;
  return left ? "left: ".concat(left, ";") : '';
});
//# sourceMappingURL=field-styled-components.js.map